import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ITicket } from "../../models/Tickets/Ticket";
import { TicketQueryKeys } from "./keys";

export default function useTicket(ticketId: string) {
  const { get } = useApiHelper();

  const ticket = useQuery({
    queryKey: TicketQueryKeys.single(ticketId),
    queryFn: () =>
      get<IDefaultResponse<ITicket>>(`/ticket/${ticketId}`).then(
        (res) => res.data,
      ),
    enabled: !!ticketId,
  });

  return {
    ticket,
  };
}
